<template>
  <div class="main-bar">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 4)"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <div class="card__category-img">
              {{ item.sub_category.name }}
            </div>
            <div
              class="bg-img-frame"
              :style="{
                background: `url(${item.image.medium})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPositionY: '0px'
              }"
            >
              <img
                class="frame-img"
                :src="require('@/assets/lifestyle-page/black-frame.png')"
                alt="Background Image"
              />
            </div>
          </div>
          <div class="card__desc">
            <div class="card__title limited-text">
              {{ item.title }}
            </div>
            <div class="data-news">
              <span class="day">{{ handleDate(item.pub_date) }},</span>
              <span class="time">{{ handleTime(item.pub_date) }}</span>
            </div>
          </div>
        </div>
      </router-link>
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: list[4].url }
          })
        "
        class="grid__item"
      >
        <div style="position: relative">
          <img
            class="imac-img"
            :src="require('@/assets/lifestyle-page/imac.png')"
            alt="Background Image"
          />

          <div class="card card-5">
            <div class="card__img">
              <div class="card__category-img">
                {{ list[4].sub_category.name }}
              </div>

              <ImageContainer
                class="img"
                :src="list[4].image.medium"
                :thumb="list[4].image.thumbnail"
                :alt="list[4].title"
              />
            </div>
            <div class="card__desc">
              <div class="card__category">
                {{ list[4].sub_category.name }}
              </div>
              <div class="card__title limited-text">
                {{ list[4].title }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(list[4].pub_date) }},</span>
                <span class="time">{{ handleTime(list[4].pub_date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return { ...useFormatter() };
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
  background: transparent;
}
.main-bar {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding-top: 6rem;
  background: url("../../../assets/lifestyle-page/main-bar-bg.jpg") no-repeat
    bottom;
  background-size: cover;
}

.bg-img-frame {
  margin: 0.5rem 0;
}

.frame-img {
  transform: scaleY(1.05);
}
.grid {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  color: #121212;
  &__item {
    padding: 0.5rem 2rem;
    grid-column: span 1;
  }
  &__item:nth-child(3),
  &__item:nth-child(4) {
    grid-column: 1 / span 2;
  }
  &__item:nth-child(5) {
    grid-column: 1 / span 2;
    padding-bottom: 0;
    transform: translateY(6%);
  }
}
.card-3,
.card-4 {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.card-5 {
  top: 0;
  width: 70%;
  display: flex;
  align-items: center;
  color: #fff;
  gap: 0.5rem;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translateX(-50%);
  .card__img {
    flex: 1;
    .img {
      padding-bottom: 70%;
    }
  }
  .card__desc {
    flex: 1;
  }
}

.card__category {
  display: none;
}
@media screen and (max-width: 767px) {
  .main-bar {
    padding-top: 4rem;
    padding-bottom: 12rem;
  }
  .grid {
    width: 90%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    color: #121212;
    gap: 1rem 1.5rem;
    &__item {
      padding: 0;
      grid-column: span 1;
    }
    &__item:nth-child(1),
    &__item:nth-child(2) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(3),
    &__item:nth-child(4) {
      grid-column: 1 / span 1;
    }
    &__item:nth-child(4) {
      grid-column: 2;
    }
    &__item:nth-child(5) {
      grid-column: 1 / span 2;
      padding-bottom: 0;
      transform: translateY(6%);
    }
    .card-1,
    .card-2 {
      width: 65%;
      margin: 0 auto;
      .card__title {
        font-size: 16px;
        line-height: 1.5;
      }
    }
    .card-3,
    .card-4 {
      flex-direction: column;
      .card__title {
        font-size: 14px !important;
        --snup: 3;
      }
    }

    .card__category-img {
      margin-bottom: 0.5rem;
    }
    .card-5 {
      position: relative;
      width: 90%;
      margin-left: auto;
      margin-right: auto;
      margin-top: 2rem;
      transform: translateY(0);
      left: 0;
      top: 0;
      .card__category-img {
        display: none;
      }
      .card__title {
        --snup: 3;
      }
      .card__category {
        display: block;
        font-family: Open Sans;
        font-size: 12px;
        line-height: 16px;

        color: rgba(255, 255, 255, 0.7);
      }
    }
  }
  .imac-img {
    display: none;
  }

  .card {
    gap: 0.5rem;
  }
}
</style>
